var HomeAddressFactory = function ($resource, $window) {
  var retrieveHomeAddressApi =
    "/participant-web-services/rest/homeAddress/retrieveHomeAddress/:stline1/:stline2/:city/:state/:zipcode/:country";
  var getAddressApi =
    "/participant-web-services/rest/participant/getAddress/:country/:state/:zipcode";
  var updateHomeAddressApi =
    "/participant-web-services/rest/homeAddress/updateHomeAddress";

  return {
    retrieveHomeAddress: $resource(
      __baseApiUrl__ + retrieveHomeAddressApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    getAddress: $resource(
      __baseApiUrl__ + getAddressApi,
      {},
      {
        query: {
          method: "GET",
          transformResponse: function (data, headers) {
            return {
              validZipcode: angular.fromJson(data),
              headersvalue: angular.fromJson(headers),
            };
          },
        },
      }
    ),

    updateHomeAddress: $resource(
      __baseApiUrl__ + updateHomeAddressApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),
  };
};

HomeAddressFactory.$inject = ["$resource", "$window"];
export default HomeAddressFactory;
